// lib/known-build.ts
//
// Module-level store (client-side only) for "what build id does THIS client
// currently believe it's running" — i.e. the buildId the page was last
// rendered with, set once by UpdateCheckerWrapper's server-stamped
// initialBuildId and kept in sync by update-checker.tsx whenever a real
// reload lands a fresh one.
//
// Exists so other client code — collectDiagnostics() (so admins can confirm
// what build a user's logs came from when troubleshooting) and the Profile
// page's visible build readout — can read it without needing update-checker
// to be mounted in their own subtree. Same plain-module-variable pattern as
// vote-gesture.ts, for the same reason: writer and readers don't share a
// subtree, and this is set rarely enough that React context would be
// overkill.

let knownBuildId: string | null = null;

export function setKnownBuildId(value: string): void {
  knownBuildId = value;
}

export function getKnownBuildId(): string | null {
  return knownBuildId;
}
